import { ErrorMessage } from '@/components/Message/ErrorMessage';
import { ChangeEvent, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface TextareaProps
  extends React.PropsWithRef<JSX.IntrinsicElements['textarea']> {
  placeholder?: string;
  defaultValue?: string;
  value?: string;
  rows?: number;
  errorMessage?: string;
  containerClassName?: string;
  textareaClassName?: string;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      placeholder,
      defaultValue,
      value,
      rows,
      errorMessage,
      containerClassName,
      textareaClassName,
      onChange,
      ...rest
    },
    ref,
  ) => {
    return (
      <div
        className={twMerge('flex flex-1 flex-col gap-0.75', containerClassName)}
      >
        <textarea
          ref={ref}
          className={twMerge(
            'textarea text-gray-5B5B5B font-normal bg-gray-100 resize-none',
            textareaClassName,
          )}
          placeholder={placeholder}
          defaultValue={defaultValue}
          value={value}
          rows={rows ?? 6}
          onChange={onChange}
          {...rest}
        />
        {errorMessage && <ErrorMessage message={errorMessage} />}
      </div>
    );
  },
);
